
import React from 'react';
import { Form, Col} from 'react-bootstrap';
import { getIn } from 'formik';
import NumberFormat from '../../NumberFormat';
import Age from '../Age';

export default class SocialSecurity extends React.Component {

     render(){
        return(
                <Form.Row>
                    <Age form={this.props.form} type={this.props.type} />
                     <Form.Group as={Col} md="4" controlId="validationFormikage">
                        <Form.Label>Start Age</Form.Label>
                        {/* <Form.Control
                                type="number"
                                value={getIn(this.props.values, `${this.props}.age`)}
                                onChange={e => {this.props.setFieldValue( `${this.props.type}.age`,e.target.value);
                                this.props.setFieldTouched( `${this.props.type}.age`,true);}}
                                isValid={getIn(this.props.touched, `${this.props.type}.age`) && !getIn(this.props.errors, `${this.props.type}.age`)}
                                isInvalid={getIn(this.props.errors, `${this.props.type}.age`) }
                        />
                        <Form.Control.Feedback type="invalid">
                            { getIn(this.props.errors, `${this.props.type}.age`) }
                        </Form.Control.Feedback>  */}
                        <NumberFormat
                            value={getIn(this.props.values, `${this.props.type}.age`)} 
                            onValueChange={e => { 
                                this.props.setFieldValue( `${this.props.type}.age`, e.floatValue);
                                this.props.setFieldTouched( `${this.props.type}.age`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.age`) }
                            format={'##'}
                            />
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationFormikAmount">
                        <Form.Label><strong>Monthly</strong> Amount</Form.Label>
                        <NumberFormat
                            value={getIn(this.props.values, `${this.props.type}.amount`)}  
                            thousandSeparator={true} 
                            prefix={'$'} 
                            onValueChange={e => { 
                                this.props.setFieldValue( `${this.props.type}.amount`, e.floatValue);
                                this.props.setFieldTouched( `${this.props.type}.amount`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.amount`) }
                            />
                    </Form.Group>
                    {/* <Form.Group as={Col} md="3" controlId="validationFormikCOLA">
                        <Form.Label>Projected COLA (%)</Form.Label>
                        <NumberFormat
                            // value={getIn(this.props.values, `${this.props}.cola`)}
                            value={this.props.cola} 
                            onValueChange={e => { 
                                console.log('e.formattedValue',e.formattedValue)
                                this.props.colachange(parseFloat(e.formattedValue))
                                this.props.setFieldValue( `${this.props.type}.cola`, parseFloat(e.formattedValue) );
                                this.props.setFieldTouched( `${this.props.type}.cola`,true);  }}
                            error={getIn(this.props.errors, `${this.props.type}.cola`) }
                            // format={decimalFormat.bind(this)}
                            suffix={'%'}
                            
                            />
                    </Form.Group> */}
                </Form.Row>
        );
    }
}